import { CHANGE_LANGUAGE } from '../actions/languageActions';
import { appOptions } from '../config/app';

export default (previousState = 'mk', { type, payload }) => {
  if (type === CHANGE_LANGUAGE) {
    localStorage.setItem(appOptions.languageKey, payload);
    return payload;
  }
  return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/languageReducer.js